import React, { FC, useState, useEffect } from 'react';
import { Checkbox } from 'antd';
import classNames from 'classnames';
import i18n from '@/content';
import styles from './RoleFilter.module.scss';
import './antOverride.scss';
import appConfig from '../../../../config/env';

interface RoleFilterProps {
    setSelectedKeys: (selectedKeys: React.Key[]) => void;
    selectedKeys: string[];
    confirm: () => void;
}

const RoleFilter: FC<RoleFilterProps> = ({ confirm, selectedKeys, setSelectedKeys }) => {
    // All possible roles (for rendering)
    const allRoles = ['Administrators', 'Auditors', 'Collaborators', 'Externals'];
    // Default checked roles
    const defaultChecked = appConfig.ROLE_FILTER_DEFAULT;

    const [checkedValues, setCheckedValues] = useState<string[]>(defaultChecked);

    useEffect(() => {
        // Notify parent of initial checked roles (only once)
        setSelectedKeys(defaultChecked);
    }, [setSelectedKeys]);

    const onChange = (newChecked: string[]): void => {
        setCheckedValues(newChecked);
        setSelectedKeys(newChecked);
        confirm(); // triggers table filter
    };

    return (
        <div className={classNames(styles['role-filter-container'], 'role-filter-container')}>
            <Checkbox.Group
                className={styles['content-box']}
                value={checkedValues} // controls checked items
                onChange={onChange}
            >
                {allRoles.map((role) => (
                    <Checkbox key={role} value={role} className={styles['role-item']}>
                        {i18n.t(`general.groups.${role}`)}
                    </Checkbox>
                ))}
            </Checkbox.Group>
        </div>
    );
};

export default RoleFilter;